export const getFundsChipContainerStyle = (isMobile) => () => ({
  display: "flex",
  alignItems: "center",
  gap: isMobile ? 0.5 : 0.75,
  px: isMobile ? 1 : 1.5,
  py: isMobile ? 0.4 : 0.5,
  borderRadius: "1.25rem",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  border: "1px solid",
  borderColor: "rgba(255, 255, 255, 0.15)",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.18)",
    borderColor: "rgba(255, 255, 255, 0.25)",
    transform: "translateY(-1px)",
  },
  "&:active": {
    transform: "translateY(0)",
  },
  userSelect: "none",
  flexShrink: 0,
});

export const getFundsChipIconStyle = (isMobile) => () => ({
  fontSize: isMobile ? "0.85rem" : "1rem", 
  color: "rgba(255,255,255,0.8)"
});

export const getFundsChipTextStyle = (isMobile) => () => ({
  color: "white",
  fontWeight: 600,
  fontSize: isMobile ? "0.7rem" : "0.8rem",
  whiteSpace: "nowrap",
});
